import { render, staticRenderFns } from "./SelectLead.vue?vue&type=template&id=05a257c2&scoped=true"
import script from "./SelectLead.vue?vue&type=script&lang=js"
export * from "./SelectLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a257c2",
  null
  
)

export default component.exports